import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import {
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import server from "../../../server";
import {
  jhatpatPincodes,
  useQuickCommerce,
} from "../../context/QuickCommerceProvider";

const locationTitle = {
  fontSize: "18px",
  fontFamily: "Poppins",
  fontWeight: "600",
};

const addressText = {
  // maxWidth: "100%",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: "400",
};

const EditButton = { backgroundColor: "#F37A20", margin: "5px 5px" };

const DeleteButton = { backgroundColor: "#FF5552", margin: "5px 5px" };

const AddressCard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDisabled =
    props.quickCommerce == "QuickCommerce" &&
    !props.jhatpatPincodes.includes(props.addressdetail.pincode);

  // const status = location?.state?.status;

  const [open1, setOpen1] = useState(false);
  const { quickCommerce, setQuickCommerce } = useQuickCommerce();
  const [status, setStatus] = useState(location?.state?.status);

  const deleteaddress = async (e) => {
    e.preventDefault();
    const result = await axios.delete(
      `${server}/address/delete/${props.addressdetail._id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      },
    );
    // navigate('/profile')
    handleClose();
    props.refresh();
    // console.log(result)
  };

  const handleClose = () => setOpen1(false);

  const changeAddress = (e) => {
    e.preventDefault();

    console.log(e.target);

    if (
      !jhatpatPincodes.includes(props.addressdetail.pincode) &&
      quickCommerce === "QuickCommerce"
    )
      return toast.error(
        "This address is not in service area for झटपट डिलिव्हरी",
      );

    if (props.status === "true") {
      // console.log(props.addressdetail)
      toast.success("Address Set", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      if (props.return) {
        // console.log("should go to return page")
        navigate(`/returnorder/${props.return}`, {
          state: {
            name: props.addressdetail.addressLine,
            _id: props.addressdetail._id,
          },
          replace: true,
        });
      } else
        navigate("/placeorder", {
          state: {
            name: props.addressdetail.addressLine,
            _id: props.addressdetail._id,
            pincode: props.addressdetail.pincode,
            recipientName: props.addressdetail.recipientName,
            recipientPhoneNo: props.addressdetail.recipientPhoneNo,
            locationType: props.addressdetail.locationType,
          },
          replace: true,
        });
    }
  };

  useEffect(() => {
    location?.state?.status ? setStatus(location?.state?.status) : null;
  }, [location?.state?.status]);

  return (
    <>
      <ToastContainer />

      <Box
        sx={{
          padding: "20px 0px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #E1E1E1",
          marginTop: "10px",
          opacity: isDisabled ? 0.5 : 1, // Dim the card if disabled
          pointerEvents: isDisabled ? "none" : "auto", // Disable interactions if disabled
        }}
      >
        <Modal
          open={open1}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "50vw",
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Are you Sure, You want to delete the address?
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                className="create-new-post-button"
                style={{
                  margin: "10px 20px",
                  backgroundColor: "#5EC401",
                }}
                onClick={deleteaddress}
              >
                Delete
              </button>
              <button
                className="create-new-post-button"
                style={{
                  margin: "10px 20px",
                  backgroundColor: "#5EC401",
                }}
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </Box>
        </Modal>
        <Box
        // onClick={(e) => changeAddress(e)}
        >
          {/* <Button sx= { { textDecoration: "none"}}> */}
          <Typography sx={locationTitle}>
            {props.addressdetail.locationType}
          </Typography>
          <Typography sx={addressText}>
            {" "}
            {props.addressdetail.addressLine}{" "}
          </Typography>
          {/* </Button> */}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* <Link to={{
          pathname: `/editaddress/${props.addressdetail._id}`, 
          state :props.status
          }
        }> */}

          {status ? (
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                // defaultValue="0"
                name="radio-buttons-group"
                onChange={(e) => {
                  // setchoice(e.target.value)
                  // setti
                  changeAddress(e);
                }}
              >
                <FormControlLabel value={0} control={<Radio />} />
              </RadioGroup>
            </FormControl>
          ) : null}

          <IconButton
            sx={EditButton}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/editaddress/${props.addressdetail._id}`, {
                state: props.status,
              });
            }}
            disabled={isDisabled}
          >
            <ModeEditOutlinedIcon sx={{ color: "#fff" }} />
          </IconButton>
          {/* </Link> */}
          <Link>
            <IconButton
              sx={DeleteButton}
              onClick={(e) => setOpen1(true)}
              disabled={isDisabled}
            >
              <DeleteOutlineRoundedIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default AddressCard;
